import { createApp } from "vue";
import Master from "./views/Master.vue";
import router from "./router";

import VueSweetalert2 from "vue-sweetalert2";

createApp(Master).use(router).use(VueSweetalert2).mount('#app');
